export default function Logo() {
  return <h1>My Travel List</h1>;
}